angular.module('lf.common')

.controller('SubscriptionUpdateCreditCardCtrl', function ($scope, $injector, subscriptionService, helpers) {
  var client = lf.data.xhr.client;
  
  var card = lf.data.subscriptionData.paymentData.creditCards && 
             lf.data.subscriptionData.paymentData.creditCards[0];
  var cardForm = $.extend(true, {}, card);

  $scope.formData = {
    months: helpers.creditCardForm.getMonths().slice(),
    years: helpers.creditCardForm.getYears().slice(),
    states: helpers.getStates().slice()
  };
  
  if (cardForm.name) {
    $.extend(cardForm, {
      number: null,
      expires: {}
    });
    
    if (client.isMobile) {
      cardForm.billingAddress.state = {
        value: cardForm.billingAddress.state
      }
    }
  }
  
  $scope.cardForm = cardForm;
  
  $scope.error = null;
  
  $scope.addOrUpdateCard = function () {
    $scope.processing = true;
    $scope.showProcessingPopup();
    
    $scope.error = null;
    
    $scope.cardForm.updateCC = true;

    subscriptionService.addOrUpdateCard($scope.cardForm)
      .then(function (data) {
        if (data.success) {
          $scope.error = null;
          console.log('SubscriptionUpdateCreditCardCtrl.addOrUpdateCard success: true', data);
          $scope.closeModal();
          window.location.reload();
        } else {
          console.log('SubscriptionUpdateCreditCardCtrl.addOrUpdateCard success: false', data);
          // handle success false
        }
      })
      .catch(function (error) {
        console.log('SubscriptionUpdateCreditCardCtrl.addOrUpdateCard', error);
        $scope.error = {};
        if (error.details && error.details.length) {
          $scope.error.message = error.details[0];
          return;
        }
        $scope.error.serverError = true;
      })
      .finally(function (data) {
        $scope.processing = false;
        $scope.hideProcessingPopup();
      });
  }  
  
  $scope.closeModal = function () {
    var isDesktop = client.isDesktop || client.isLFC;
    var modal = $injector.get(isDesktop ? 'popupsService' : 'slideinService');
    modal.hide('update-credit-card');
  }
  
});
